import DapDSCalendarCell from './calendar-cell.component'

export * from './calendar-cell.component'
export default DapDSCalendarCell

DapDSCalendarCell.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-calendar-cell': DapDSCalendarCell
  }
}
